export const RECREATE_SUBSCRIPTION = '30 days';

export const INSTALL_SW_FREQUENCY = '30 days';
